// FieldConfig.js

export class FieldConfig {
  constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = '', IsVisible = "ReadWrite",
    //  PagePermission = 'disable'
    //  ,
    place = '', value = "") {
    this.key = key;
    this.label = label;
    this.placeholder = placeholder;
    this.priority = priority;
    this.type = type;
    this.visibility = visibility;
    this.IsVisible = IsVisible;
    // this.PagePermission = PagePermission;
    this.place = place;
    this.value = value;

  }

  // Method to update visibility based on API response
  setVisibility(isVisible) {
    this.isVisible = isVisible;
  }
}




export const AddStockFields = [

  new FieldConfig("VendorId", "Supplier", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("SKUId", "SKU", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("LotNumber", "Lot Number", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("StockType", "Stock Type", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("Branch", "Branch", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabelgold", "Unlabel Gold", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabelsilver", "Unabel Silver", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabeldiamond", "Unlabel Diamond", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabelother", "Unlabel Other", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  //label
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("CollectionId", "Collection", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PacketId", "Packet", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("BoxId", "Box", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("mainstone", "Select stones", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WeightCategory", "Weight Categories", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Quantity", "Quantity", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("TotalWeight", "Total Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("GrossWt", "Gross Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("TotalStoneWeight", "Stone Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("NetWt", "Net Wt", "", 1, "inputdecimal", "ReadOnly", "ReadOnly", "middle"),
  new FieldConfig("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingPerGram", "Making/Grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingFixedAmt", "Fixed Making", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingFixedWastage", "Making Fixed Wastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("ClipWeight", "Clip Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ClipQuantity", "Clip Qty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("ProductName", "Product Name", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  

  //loose diamonds
  new FieldConfig("DiamondShape", "Diamond shape", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondClarity", "Diamond Clarity", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondColour", "Diamond Colour", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSleve", "Diamond sleves", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondWeight", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSellRate", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondPieces", "D Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("images", "Totalweight", "", 1, "imagesbox", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("totalamount", "Totalamount", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondCut", "Diamond Cut", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSettingType", "Diamond Setting", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondCertificate", "certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondDescription", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  
  //unlabel gold
  new FieldConfig("FinePercent", "Fine", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WastagePercent", "Wastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("FineWastage", "Fine+Wastage", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("Stones", "Stones", "", 1, "popup", "ReadWrite", "Hidden", "middle"),
  new FieldConfig("DButton", "Diamonds", "", 1, "popup", "ReadWrite", "Hidden", "middle"),
  
  new FieldConfig("importbtn", "Import", "", 1, "button", "ReadWrite", "ReadWrite", "middle"),
  
  //stones
  new FieldConfig("StoneName", "Stone Name", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneColor", "Stone Colour ", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneShape", "Stone Shape", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneSize", "Stone Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneWeight", "Stone Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StonePieces", "Stone Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneRatePiece", "Stone Rate/Piece", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneRateKarate", "Stone Rate/Karate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneDescription", "Stone Description", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneCertificate", "Stone Certificate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneSettingType", "Stone Setting", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  







  
  
  //grid


  new FieldConfig("VendorId", "Vendor", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("SKUId", "SKU", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("ItemCode", "ItemCode", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("RFIDCode", "RFIDCode", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TIDNumber", "TidValue", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("TotalWeight", "TotalWT", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  // new FieldConfig("TotalStoneWeight", "TStoneWT", "", 1, "read", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfig("GrossWt", "Grosswt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalStoneWeight", "StoneWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ClipWeight", "ClipWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ClipQuantity", "ClipQty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("NetWt", "Netwt", "", 1, "inputdecimal", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("Size", "Size", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductTitle", "Producttitle", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductCode", "Product Code", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("HUIDCode", "Huid", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("HallmarkAmount", "Hallmark", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalStoneAmount", "TotalSAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingPerGram", "Making/grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingFixedAmt", "MakingFixedAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingFixedWastage", "MakingFixedWastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("OtherWeight", "Other weight ", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PouchWeight", "Pouch weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TagWeight", "Tag weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("FindingWeight", "Finding weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("LanyardWeight", "Lanyard weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("OccassionName", "Occcassion", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Status", "status", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Featured", "Featured", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Metal", "Metal", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("DiamondShape", "D Shape", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondClarity", "D Clarity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondColour", "D Colour", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondCut", "D Cut", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSleve", "Diamond Sleves", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondWeight", "Diamond wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSettingType", "D SettingType", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondCertificate", "Diamond certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondDescription", "D Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfig("DiamondName", "Diamond Name", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondAmount", "Diamond Amount", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondPieces", "Diamond Pcs", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalDiamondWeight", "D Purchase Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalDiamondAmount", "D Sell Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("StoneName", "Stone Name", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneColor", "Stone Colour ", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneShape", "Stone Shape", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneSize", "Stone Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneWeight", "Stone Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StonePieces", "Stone Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneRatePiece", "Stone Rate/Piece", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneRateKarate", "Stone Rate/Karate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneDescription", "Stone Description", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneCertificate", "Stone Certificate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneSettingType", "Stone Setting", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("Stones", "Stones", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DButton", "Diamonds", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", "ReadWrite", "grid"),


];



export const AddStockLooseStoneFieldsNew = [ 
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("CollectionId", "Collection", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PacketId", "Packet", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("BoxId", "Box", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("mainstone", "Select stones", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WeightCategory", "Weight Categories", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Quantity", "Quantity", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("TotalWeight", "Total Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("GrossWt", "Gross Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

]

export class FieldConfigNew {
  constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = '', IsVisible = "ReadWrite",
    //  PagePermission = 'disable'
    //  ,
    place = '', value = "",mandatory=false) {
    this.key = key;
    this.label = label;
    this.placeholder = placeholder;
    this.priority = priority;
    this.type = type;
    this.visibility = visibility;
    this.IsVisible = IsVisible;
    // this.PagePermission = PagePermission;
    this.place = place;
    this.value = value;
    this.mandatory = mandatory

  }

  // Method to update visibility based on API response
  setVisibility(isVisible) {
    this.isVisible = isVisible;
  }
}


export const AddStockNormalFieldsNew = [

  new FieldConfigNew("VendorId", "Vendor", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top","",true),
  new FieldConfigNew("SKUId", "SKU", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfigNew("LotNumber", "Lot Number", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfigNew("LotWeight", "Lot Weight", "", 1, "text", "ReadOnly", "ReadOnly", "top"),
  // new FieldConfigNew("StockType", "Stock Type", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top","",true),
  new FieldConfigNew("Branch", "Branch", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top","",true),
 
  new FieldConfigNew("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
  new FieldConfigNew("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
  new FieldConfigNew("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
  new FieldConfigNew("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
   new FieldConfigNew("CollectionId", "Collection", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("PacketId", "Packet", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("BoxId", "Box", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("mainstone", "Select stones", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("WeightCategory", "Wt Categories", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("Quantity", "Quantity", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfigNew("TotalWeight", "Total Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("PackingWeight", "Packing Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfigNew("GrossWt", "Gross Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfigNew("TotalStoneWeight", "Stone Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("StonePieces", "Stone Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("DiamondWeight", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("DiamondPieces", "Diamond Pcs", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("NetWt", "Net Wt", "", 1, "inputdecimal", "ReadOnly", "ReadOnly", "middle"),
  new FieldConfigNew("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("MakingPerGram", "Making/Grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("MakingFixedAmt", "Fixed Making", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("MakingFixedWastage", "Making Fixed Wastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfigNew("ClipWeight", "Clip Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("ClipQuantity", "Clip Qty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfigNew("ProductName", "Product Name", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfigNew("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  

  //grid


  new FieldConfigNew("VendorId", "Vendor", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("SKUId", "SKU", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),

  // new FieldConfig("ItemCode", "ItemCode", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfigNew("RFIDCode", "RFIDCode", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("TIDNumber", "TidValue", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfigNew("TotalWeight", "TotalWT", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  // new FieldConfig("TotalStoneWeight", "TStoneWT", "", 1, "read", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfigNew("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfigNew("GrossWt", "Grosswt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("TotalStoneWeight", "StoneWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("StonePieces", "Stone Pcs", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("DiamondWeight", "Diamond Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("DiamondPieces", "Diamond Pcs", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfigNew("ClipWeight", "ClipWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("ClipQuantity", "ClipQty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("NetWt", "Netwt", "", 1, "inputdecimal", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfigNew("Size", "Size", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("ProductTitle", "Producttitle", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("ProductCode", "Product Code", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("HUIDCode", "Huid", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("HallmarkAmount", "Hallmark", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("TotalStoneAmount", "TotalSAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("MakingPerGram", "Making/grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("MakingFixedAmt", "MakingFixedAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("MakingFixedWastage", "MakingFixedWastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("OtherWeight", "Other weight ", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("PouchWeight", "Pouch weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("TagWeight", "Tag weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("FindingWeight", "Finding weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("LanyardWeight", "Lanyard weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfigNew("OccassionName", "Occcassion", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Status", "status", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("Featured", "Featured", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Metal", "Metal", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfigNew("Stones", "Stones", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", "ReadWrite", "grid"),


];
export const AddStockUnlabelledFieldsNew = [
  new FieldConfigNew("VendorId", "Vendor", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top","",true),
  new FieldConfigNew("SKUId", "SKU", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfigNew("LotNumber", "Lot Number", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfigNew("LotWeight", "Lot Weight", "", 1, "text", "ReadOnly", "ReadOnly", "top"),

new FieldConfigNew("Branch", "Branch", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top","",true),
new FieldConfigNew("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
new FieldConfigNew("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
new FieldConfigNew("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
new FieldConfigNew("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
new FieldConfigNew("PacketId", "Packet", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("BoxId", "Box", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("TotalWeight", "Total Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("PackingWeight", "Packing Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("GrossWt", "Gross Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("TotalStoneWeight", "Stone Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("DiamondWeight", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("NetWt", "Net Wt", "", 1, "inputdecimal", "ReadOnly", "ReadOnly", "middle"),
new FieldConfigNew("Quantity", "Quantity", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("FinePercentage", "Fine %", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("WastagePercentage", "Wastage %", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
new FieldConfigNew("FineWastageWt", "F + W Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

]
export const AddStocklooseDiamondNewFields = [
  new FieldConfigNew("VendorId", "Vendor", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top","",true),
  new FieldConfigNew("SKUId", "SKU", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfigNew("LotNumber", "Lot Number", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfigNew("StockType", "Stock Type", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top","",true),
  new FieldConfigNew("Weight", "Weight", "", 1, "text", "ReadOnly", "ReadWrite", "top","",false),
  new FieldConfigNew("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
  new FieldConfigNew("DiamondName", "Diamond Name", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",true),
  new FieldConfigNew("DiamondShape", "Diamond Shape", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondColour", "Diamond Colour", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondClarity", "Diamond Clarity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondSleve", "Diamond Sleve", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondSize", "Diamond Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondWeight", "Diamond Weight", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondPieces", "Diamond Pieces", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondSellRate", "Diamond Rate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondAmount", "Diamond Amount", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondCut", "Diamond Cut", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondSettingType", "Diamond Setting", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondCertificate", "Certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondPacket", "Packet", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondBox", "Box", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),
  new FieldConfigNew("DiamondDescription", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle","",false),

  // ------- grid ------------

  new FieldConfigNew("VendorId", "Vendor", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",true),
  new FieldConfigNew("SKUId", "SKU", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfigNew("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",true),
  new FieldConfigNew("DiamondName", "Diamond Name", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",true),
  new FieldConfigNew("DiamondShape", "Diamond Shape", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondColour", "Diamond Colour", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondClarity", "Diamond Clarity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondSleve", "Diamond Sleve", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondSize", "Diamond Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondWeight", "Diamond Weight", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondPieces", "Diamond Pieces", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondSellRate", "Diamond Rate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondAmount", "Diamond Amount", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondCut", "Diamond Cut", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondSettingType", "Diamond Setting", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondCertificate", "Certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondPacket", "Packet", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondBox", "Box", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
  new FieldConfigNew("DiamondDescription", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid","",false),
]

export const AddStockFieldsNew = [

  new FieldConfig("VendorId", "Supplier", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("SKUId", "SKU", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("LotNumber", "Lot Number", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("StockType", "Stock Type", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("Branch", "Branch", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top"),
 
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("CollectionId", "Collection", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("mainstone", "Select stones", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WeightCategory", "Weight Categories", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Quantity", "Quantity", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("TotalWeight", "Total Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("GrossWt", "Gross Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("TotalStoneWeight", "Stone Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("NetWt", "Net Wt", "", 1, "inputdecimal", "ReadOnly", "ReadOnly", "middle"),
  new FieldConfig("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingPerGram", "Making/Grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingFixedAmt", "Fixed Making", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingFixedWastage", "Making Fixed Wastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("ClipWeight", "Clip Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ClipQuantity", "Clip Qty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("ProductName", "Product Name", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  

  //loose diamonds
  new FieldConfig("DiamondShape", "Diamond shape", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondClarity", "Diamond Clarity", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondColour", "Diamond Colour", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSleve", "Diamond sleves", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondWeight", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSellRate", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondPieces", "D Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("images", "Totalweight", "", 1, "imagesbox", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("totalamount", "Totalamount", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondCut", "Diamond Cut", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSettingType", "Diamond Setting", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondCertificate", "certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondDescription", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  
  //unlabel gold
  new FieldConfig("FinePercent", "Fine", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WastagePercent", "Wastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("FineWastage", "Fine+Wastage", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("Stones", "Stones", "", 1, "popup", "ReadWrite", "Hidden", "middle"),
  new FieldConfig("DButton", "Diamonds", "", 1, "popup", "ReadWrite", "Hidden", "middle"),
  
  new FieldConfig("importbtn", "Import", "", 1, "button", "ReadWrite", "ReadWrite", "middle"),
  
  //stones
  new FieldConfig("StoneName", "Stone Name", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneCategory", "Stone Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneColor", "Stone Colour ", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneShape", "Stone Shape", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneSize", "Stone Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneWeight", "Stone Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StonePieces", "Stone Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneRatePiece", "Stone Rate/Piece", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneRateKarate", "Stone Rate/Karate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneDescription", "Stone Description", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneCertificate", "Stone Certificate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneSettingType", "Stone Setting", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  







  
  
  //grid


  new FieldConfig("VendorId", "Vendor", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("SKUId", "SKU", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("ItemCode", "ItemCode", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("RFIDCode", "RFIDCode", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TIDNumber", "TidValue", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("TotalWeight", "TotalWT", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  // new FieldConfig("TotalStoneWeight", "TStoneWT", "", 1, "read", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfig("GrossWt", "Grosswt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalStoneWeight", "StoneWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ClipWeight", "ClipWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ClipQuantity", "ClipQty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("NetWt", "Netwt", "", 1, "inputdecimal", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("Size", "Size", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductTitle", "Producttitle", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductCode", "Product Code", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("HUIDCode", "Huid", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("HallmarkAmount", "Hallmark", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalStoneAmount", "TotalSAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingPerGram", "Making/grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingFixedAmt", "MakingFixedAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingFixedWastage", "MakingFixedWastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("OtherWeight", "Other weight ", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PouchWeight", "Pouch weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TagWeight", "Tag weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("FindingWeight", "Finding weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("LanyardWeight", "Lanyard weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("OccassionName", "Occcassion", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Status", "status", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Featured", "Featured", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Metal", "Metal", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("DiamondShape", "D Shape", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondClarity", "D Clarity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondColour", "D Colour", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondCut", "D Cut", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSleve", "Diamond Sleves", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondWeight", "Diamond wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSettingType", "D SettingType", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondCertificate", "Diamond certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondDescription", "D Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfig("DiamondName", "Diamond Name", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondAmount", "Diamond Amount", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondPieces", "Diamond Pcs", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalDiamondWeight", "D Purchase Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalDiamondAmount", "D Sell Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("StoneName", "Stone Name", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneColor", "Stone Colour ", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneShape", "Stone Shape", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneSize", "Stone Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneWeight", "Stone Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StonePieces", "Stone Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneRatePiece", "Stone Rate/Piece", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneRateKarate", "Stone Rate/Karate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneDescription", "Stone Description", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneCertificate", "Stone Certificate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("StoneSettingType", "Stone Setting", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("Stones", "Stones", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DButton", "Diamonds", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", "ReadWrite", "grid"),


];
